import { Component, OnInit } from '@angular/core';

import { IndicadorService } from '../services/indicador.service';
import { GlobalsService } from '../services/globals.service';
import { PuntoVisitaService } from '../services/punto-visita.service';
import { Indicadores } from '../Models/Indicadores';
import { PuntoVisita } from '../Models/PuntoVisita';
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-indicador-visita-cliente',
  templateUrl: './indicador-visita-cliente.component.html',
  styleUrls: ['./indicador-visita-cliente.component.css']
})
export class IndicadorVisitaClienteComponent implements OnInit {

  indicador: Indicadores = new Indicadores();
  indicadores: Indicadores[] = [];

  puntoVisita: PuntoVisita = new PuntoVisita();
  puntosVisitas: PuntoVisita[] = [];

  fechaInicio: Date;
  fechaFin: Date;

  numeroVisitas: number = 0;

  public mostrarDetalle: boolean = false;


  constructor(
    private indicadorService: IndicadorService,
    private globalServices: GlobalsService,
    private PuntoVisitaService: PuntoVisitaService
  ) { }

  ngOnInit() {
    this.puntosVisitas=[];
    this.ObtenerPuntosVisita();

  }


  /**
   * Se obtiene el encabezado 
   */
  ObtenerVisitaClienteEnc() {

    if (isNullOrUndefined(this.fechaInicio)) {
      this.fechaInicio = new Date();
    }
    if (isNullOrUndefined(this.fechaFin)) {
      this.fechaFin = new Date();
    }

    if (isNullOrUndefined(this.puntoVisita.idPunto)) {
      return;
    }

    this.indicadorService.ObtenerVisitaClienteEnc(
      this.globalServices.ObtenerCompania(),
      this.puntoVisita.idPunto, this.fechaInicio, this.fechaFin).subscribe(
        data => {
          this.indicadores =  JSON.parse(JSON.stringify(data));

        

         var index = this.puntosVisitas.findIndex(s => s.idPunto === this.puntoVisita.idPunto);

         this.puntoVisita=  JSON.parse(JSON.stringify(this.puntosVisitas[index]));

          this.indicadores.forEach(element => {
            this.numeroVisitas = this.numeroVisitas + Number.parseInt(element.resultado);
          });

        }
      );

  }

  /**
   * obtiene los puntos de visita
   * para el combo box de el
   */
  ObtenerPuntosVisita() {
    this.PuntoVisitaService.ObtenerPuntoVisitas(this.globalServices.ObtenerCompania())
      .subscribe(
        data => {
          this.puntosVisitas = JSON.parse(JSON.stringify(data));
        }
      );
  }


  RegistroSeleccionado(item) {

    this.indicador = JSON.parse(JSON.stringify(item));


    this.puntoVisita = this.puntosVisitas.find(f => f.idPunto == this.indicador.idPunto);

  }

  /**
   * Convierte la tabla asignada en un exel
   * @param tableID 
   * @param filename 
   */
  exportTableToExcel(tableID, filename = '') {

    if (this.indicadores.length == 0) {
      return;
    }

    var downloadLink;
    var dataType = 'application/vnd.ms-excel';
    var tableSelect = document.getElementById(tableID);
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Specify file name
    filename = filename ? filename + '.xls' : 'excel_data.xls';

    // Create download link element
    downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      var blob = new Blob(['\ufeff', tableHTML], {
        type: dataType
      });
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }
  }

}
